import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import * as Sentry from "@sentry/react";
import { Preferences } from '@capacitor/preferences';

const apiURL = `${import.meta.env.VITE_EBIORO_API}`;
const ebioroApiDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';

const ebioroAxiosInstance = axios.create(
  {
    baseURL: `${apiURL}`,
    headers: {
      accept: `application/json`
    }
  })

const axiosBaseQuery = (): BaseQueryFn<AxiosRequestConfig> => async (requestOpts, { getState }) => {

  try {

    // let token = (getState() as RootState).sep10AuthToken.tokens[ebioroApiDomain];

    // if (!token){
    //   // in case no state we take it from localStorage
      const storedToken = await Preferences.get({key:ebioroApiDomain}) as any;

      if (storedToken && storedToken.value){

        const token = JSON.parse(storedToken.value)[ebioroApiDomain]

        const result = await ebioroAxiosInstance({
          ...requestOpts,
          headers: requestOpts.headers ?
            requestOpts.headers :
            {
    
              Authorization: 'Bearer ' + `${token}`
            }
        });
    
        return { data: result.data };

      }

      const result = await ebioroAxiosInstance({...requestOpts});
  
      return { data: result.data };

  } catch (axiosError) {
    const err = axiosError as AxiosError;

    Sentry.captureException(err.response?.data || err.message);

    return {
      error: {
        status: err.response?.status,
        data: err.response?.data || err.message,
      },
    };
  }
};

export const ebioroBaseQuery = axiosBaseQuery();